// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2gLdh","header":"PatientBlock_header__2xsSv","label":"PatientBlock_label__3-Ud7","option":"PatientBlock_option__pB43b"};